<template>
	<div class="thumb_list" v-if="isThumbShow">
		<div class="table_main" :style="{ height: (isUploadImg || allisTurnIng) && !zhError ? '100%' : '323px' }">
			<div class="title" v-if="!isUploadImg && !allisTurnIng && !zhError && !isMergeTurn">
				<div v-if="!isDown">
					<span v-if="pageType == 'toimg'">
						已选择 {{ selectData.length + "/" + fileList.length }}
						<span style="padding-left: 24px; color: #14a8f0">单次转换仅支持前20页</span>
					</span>
					<span v-else>已添加 {{ fileList.length }} 张图片</span>
				</div>
				<div v-else>
					<span>已成功转换{{ fileList.length }}张图片</span>
				</div>
			</div>
			<el-table ref="multipleTableTxt" class="table_box"
				:class="[pageType == 'toofd' || pageType == 'imgtoofd' ? 'no_class' : '', isDown ? 'class_isdown' : '']"
				row-key="id" v-if="!isUploadImg && !allisTurnIng && !zhError && !isMergeTurn" :data="fileList"
				:show-header="false" :row-class-name="chooseClass" @selection-change="handleSelectionChange"
				@row-click="pinSelect" @row-dblclick="openBtn"
				:max-height="!isUploadImg && !allisTurnIng && !zhError && !isMergeTurn && !isDown ? 277 : pageType == 'toimg' && isDown ? 277 : 323">
				<el-table-column type="selection" width="40" v-bind:selectable="chkstu"></el-table-column>
				<el-table-column>
					<template slot-scope="scope">
						<div class="fail_bj" v-if="
							(!scope.row.upLoadSuccess && !allzhSuccessEnd) ||
							scope.row.ghz ||
							scope.row.sfileType == 'tiff' ||
							scope.row.sfileType == 'tif' ||
							scope.row.sfileType == 'TIFF' ||
							scope.row.sfileType == 'TIF'
						"></div>
						<div class="pic"
							v-if="scope.row.sfileType == 'tiff' || scope.row.sfileType == 'tif' || scope.row.sfileType == 'TIFF' || scope.row.sfileType == 'TIF'">
							<img src="@comm/images/document-conversion/tiff_icon.svg"
								v-if="scope.row.upLoadSuccess || pageType == 'toimg'"
								@error="handleImgError($event, scope.row)" :class="{ iconImg: isLowVerIE }" />
							<img src="@comm/images/document-conversion/img_pl.svg" v-else
								:class="{ iconImg: isLowVerIE }" />
							<div class="repoll_btn" v-if="!scope.row.upLoadSuccess && !allzhSuccessEnd"
								@click.stop="onFileAdded(scope.row, 'isReUpload')">重试</div>
						</div>
						<div class="pic" v-if="
							scope.row.sfileType == 'jpg' ||
							scope.row.sfileType == 'png' ||
							scope.row.sfileType == 'JPG' ||
							scope.row.sfileType == 'PNG' ||
							scope.row.sfileType == 'bmp' ||
							scope.row.sfileType == 'BMP'
						">
							<img :src="scope.row.url" v-if="scope.row.upLoadSuccess || scope.row.zhSuccess"
								@error="handleImgError($event, scope.row)"
								:class="{ longPic: isLowVerIE, iconImg: !!scope.row.ghz }" />
							<img src="@comm/images/document-conversion/img_pl.svg" v-else
								:class="{ iconImg: isLowVerIE }" />
							<div class="repoll_btn" v-if="!scope.row.upLoadSuccess && !allzhSuccessEnd"
								@click.stop="onFileAdded(scope.row, 'isReUpload')">重试</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column>
					<template slot-scope="scope">
						<p :style="{ color: !scope.row.upLoadSuccess && !allzhSuccessEnd ? '#8B97AF' : '#242F44' }"
							v-if="pageType != 'toimg'">{{ scope.$index + 1 }}</p>
						<a class="name" v-if="pageType == 'toimg' && !scope.row.zhSuccess" :title="scope.$index + 1"
							:style="{ color: !scope.row.upLoadSuccess && !allzhSuccessEnd ? '#8B97AF' : '#242F44' }">{{
									scope.$index + 1
							}}</a>
						<a class="name" :title="scope.row.name + '.' + scope.row.fileType"
							v-if="pageType != 'toimg' || scope.row.zhSuccess"
							:style="{ color: !scope.row.upLoadSuccess && !allzhSuccessEnd ? '#8B97AF' : '#242F44' }">{{
									scope.row.name | ellipsis
							}}{{ "." + scope.row.fileType }}</a>
					</template>
				</el-table-column>
				<el-table-column v-if="pageType != 'toimg' || (pageType == 'toimg' && isDown)">
					<template slot-scope="scope">
						<div class="hover_bj" v-if="scope.row.upLoadSuccess || isDown"></div>
						<a title="删除" class="del_icon" @click.stop="suspendBtn(scope.row)"></a>
						<div class="icon_box" v-if="
							scope.row.sfileType != 'tiff' &&
							scope.row.sfileType != 'TIFF' &&
							scope.row.sfileType != 'tif' &&
							scope.row.sfileType != 'TIF' &&
							!fileList[scope.$index].ghz &&
							scope.row.upLoadSuccess
						">
							<a title="查看" class="open" @click.stop="openBtn(scope.row)">
								<i class="fdj_hs_icon"></i>查看
							</a>
						</div>
					</template>
				</el-table-column>
				<el-table-column v-if="pageType == 'toimg'">
					<template slot-scope="scope">
						<el-popover placement="center" title width="136" trigger="click"
							v-if="!isDown && scope.$index > 19" content="单次转换仅支持前20页">
							<div class="hover_bj tips" slot="reference"></div>
						</el-popover>
						<div class="hover_bj" v-if="!isDown && scope.$index <= 19"></div>
						<div class="icon_box" v-if="isDown">
							<a class="open down" title="下载" @click.stop="downdImgBtn(scope.row)">
								<i class="downimg_icon"></i>下载
							</a>
							<a class="open" title="查看" @click.stop="openBtn(scope.row)">
								<i class="fdj_hs_icon"></i>查看
							</a>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="no_list" v-if="(isUploadImg || allisTurnIng || zhError) && !isMergeTurn">
				<div class="no_file" v-if="isUploadImg">
					<div v-if="!zhError">
						<img src="@comm/images/document-conversion/upload_pdf.svg"
							v-if="pageType == 'toimg' && originFileId.fileTypeCase == 'pdf'" alt />
						<img src="@comm/images/document-conversion/upload_ofd.png"
							v-if="pageType == 'toimg' && originFileId.fileTypeCase == 'ofd'" alt />
						<img src="@comm/images/document-conversion/zip_icon.png" v-if="pageType != 'toimg'" alt />
						<div id="loading1">
							<div class="demo1"></div>
							<div class="demo1"></div>
							<div class="demo1"></div>
						</div>
						<p>文件上传中</p>
					</div>
					<div v-else>
						<div class="fail_box">
							<img src="@comm/images/document-conversion/pdf_pl.svg"
								v-if="pageType == 'toimg' && originFileId.fileTypeCase == 'pdf'" alt />
							<img src="@comm/images/document-conversion/ofd_pl.svg"
								v-if="pageType == 'toimg' && originFileId.fileTypeCase == 'ofd'" alt />
							<img src="@comm/images/document-conversion/img_pl.svg" v-if="pageType != 'toimg'" alt />
							<a :title="originFileId.name + '.' + originFileId.fileType">
								{{ originFileId.name.length > 15 ? originFileId.slname : originFileId.name }}
								{{ "." + originFileId.fileType }}
							</a>
							<div class="cs_button_box">
								<span>上传失败</span>
								<el-button class="agin_btn" @click="onFileAdded(fileList[0], 'isReUpload')">重试
								</el-button>
							</div>
						</div>
					</div>
				</div>

				<div class="turn_ing" v-if="!zhError && allisTurnIng">
					<div class="turn_box">
						<img src="@comm/images/document-conversion/home/turn_icon_ofd.png" alt
							v-if="originFileId.fileTypeCase == 'ofd' && pageType == 'toimg'" style="margin: 0" />
						<img src="@comm/images/document-conversion/upload_pdf.svg" alt
							v-if="originFileId.fileTypeCase == 'pdf' && pageType == 'toimg'" style="margin: 0" />
						<img src="@comm/images/document-conversion/zip_icon.png" alt v-if="pageType != 'toimg'"
							style="margin: 0" />
						<div id="loading1">
							<div class="demo1"></div>
							<div class="demo1"></div>
							<div class="demo1"></div>
						</div>
						<img src="@comm/images/document-conversion/home/turn_icon_ofd.png" alt
							v-if="(radio == 'ofd' || radio == 'OFD' || originFileId.fileType == 'ofd' || originFileId.fileType == 'OFD') && pageType != 'toimg'"
							style="margin: 0" />
						<img src="@comm/images/document-conversion/upload_pdf.svg" alt
							v-if="(radio == 'pdf' || radio == 'PDF' || originFileId.fileType == 'pdf' || originFileId.fileType == 'PDF') && pageType != 'toimg'"
							style="margin: 0" />
						<img src="@comm/images/document-conversion/zip_icon.png" alt v-if="pageType == 'toimg'"
							style="margin: 0" />
					</div>
					<p>文件转换中</p>
				</div>
				<div class="turn_ing" v-if="zhError && !allisTurnIng && !isUploadImg">
					<div class="fail_box">
						<img src="@comm/images/document-conversion/ofd_pl.svg" alt
							v-if="radio == 'ofd' || radio == 'OFD' || originFileId.fileType == 'ofd' || originFileId.fileType == 'OFD'"
							style="margin: 0" />
						<img src="@comm/images/document-conversion/pdf_pl.svg" alt
							v-if="radio == 'pdf' || radio == 'PDF' || originFileId.fileType == 'pdf' || originFileId.fileType == 'PDF'"
							style="margin: 0" />
						<!-- <img
							src="@comm/images/document-conversion/img_pl.svg"
							alt=""
							v-if="pageType == 'toimg'"
							style="margin: 0"
						/>-->
						<a :title="originFileId.name + '.' + originFileId.fileType">
							{{ originFileId.name.length > 15 ? originFileId.slname : originFileId.name }}
							{{ "." + originFileId.fileType }}
						</a>
						<div class="cs_button_box">
							<span>转换失败</span>
							<el-button class="agin_btn" @click="getTransfer('isReTurn')">重试</el-button>
						</div>
					</div>
				</div>
			</div>
			<merge-turn :isMergeTurnData="isMergeTurn" :MergeTurnData="MergeData"></merge-turn>
		</div>
		<div class="table_bottom" v-if="(!isUploadImg && !allisTurnIng) || zhError">
			<div class="left">
				<el-popover placement="top-start" width="300" v-model="visible">
					<p style="margin-bottom: 50px">确认将列表中的全部文件删除吗？</p>
					<div style="text-align: right; margin: 0">
						<el-button type="primary" size="mini" class="mini_btn" @click="submitBtn">删除</el-button>
						<el-button size="mini" type @click="visible = false">取消</el-button>
					</div>
					<el-button slot="reference" :disabled="(isUploadImg && !zhError) || allisTurnIng"
						v-if="pageType != 'toimg' && !zhError && !allzhSuccessEnd">清空列表</el-button>
				</el-popover>
				<div class="hb_box" v-if="!isDown && !zhError">
					<el-checkbox @change="handleCheckAllChange" v-model="isCheckbox" :checked="isCheckbox"
						:disabled="isUploadImg || allisTurnIng || isDown || isLongImgend || zhError"
						v-if="pageType == 'toimg'">{{ fileList.length > 20 ? "选择前20张" : "全选" }}</el-checkbox>
					<div class="radio_box" :class="{
						disabled: isUploadImg || allisTurnIng || isDown || isLongImgend || zhError
					}" v-if="pageType == 'toimg'">
						输出格式：
						<el-radio v-model="radio" :label="originFileId.fileTypeCase == 'ofd' ? '3' : '6'"
							:disabled="isUploadImg || allisTurnIng || isDown || isLongImgend || zhError">JPG</el-radio>
						<el-radio v-model="radio" :label="originFileId.fileTypeCase == 'ofd' ? '4' : '7'"
							:disabled="isUploadImg || allisTurnIng || isDown || isLongImgend || zhError">PNG</el-radio>
						<!-- <el-radio
						v-model="radio"
						:label="originFileId.fileTypeCase == 'ofd' ? '5' : '8'"
						:disabled="
							isUploadImg || allisTurnIng || isDown || isLongImgend || zhError
						"
						>TIFF</el-radio
						>-->
					</div>
					<div class="radio_box" :class="{
						disabled: isUploadImg || allisTurnIng || isDown || isLongImgend || zhError
					}" v-else>
						输出格式：
						<el-radio v-model="radio" label="ofd"
							:disabled="isUploadImg || allisTurnIng || isDown || isLongImg || zhError">OFD</el-radio>
						<el-radio v-model="radio" label="pdf"
							:disabled="isUploadImg || allisTurnIng || isDown || isLongImgend || zhError">PDF</el-radio>
					</div>
					<el-checkbox @change="chooseLong" v-model="isLongImg"
						:disabled="isUploadImg || allisTurnIng || isDown || isLongImgend || zhError"
						v-if="pageType == 'toimg'">
						输出长图
						<span>（每张长图可包含页面数量≤10）</span>
					</el-checkbox>
					<div class="hb_box"
						v-if="!allzhSuccessEnd && !isUploadImg && !allisTurnIng && uploadSuccessList.length != fileList.length">
						<i class="tips_icon"></i>
						<span style="color: #e02020">上传失败的文件无法进行转换</span>
					</div>
				</div>
			</div>
			<div class="right">
				<uploader ref="uploader" :options="options" :autoStart="false"
					v-if="!allisTurnIng && !allzhSuccessEnd && ((!isUploadImg && !zhError) || (isUploadImg && zhError))"
					@file-added="onFileAdded" @files-submitted="onSubmitted"
					class="uploader-app el-button el-button--default el-popover__reference">
					<uploader-btn :attrs="attrs" ref="uploadBtn" :single="pageType == 'toimg'">{{ pageType == "toimg" ?
							"打开文件" : "添加文件"
					}}</uploader-btn>
				</uploader>
				<el-button class="downZip" @click="downdBtn" :disabled="isDowning" :class="{ disable: isDowning }"
					v-if="allzhSuccessEnd && isDown && fileList.length > 1">
					<div v-if="!isDowning">打包下载</div>
					<div v-else>
						<i class="downing_icon"></i>
						打包下载
					</div>
				</el-button>
				<el-button v-if="(!allzhSuccessEnd && !zhError) || (isUploadImg && zhError)" type="primary"
					:disabled="isUploadImg || allisTurnIng || isDown || isLongImgend || zhError" @click="changeTurn">{{
							allisTurnIng ? "转换中..." : "开始转换"
					}}</el-button>

				<el-button v-if="(!isUploadImg && !allisTurnIng && allzhSuccessEnd) || (!isUploadImg && zhError)"
					type="primary" @click="reLoadTurn">继续转换</el-button>
			</div>
		</div>
		<el-image-viewer v-if="showViewer" :url-list="[viewImg]"></el-image-viewer>
		<!-- 合并弹框 -->
		<el-dialog title="文档命名" :visible.sync="dialogDownZip" class="changephone_box merge"
			:close-on-click-modal="false" width="460px" :center="false" :show-close="false" append-to-body>
			<div class="content">
				<el-input ref="textFolder" type="text" placeholder="请输入文件名称" v-model="downZipName" maxlength="25">
				</el-input>
				<span>.{{ radio }}</span>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" @click="submitFolder" :disabled="downZipName ? false : true">确 定
				</el-button>
				<el-button @click="dialogDownZip = false" size="mini">取 消</el-button>
			</div>
		</el-dialog>
		<!-- 继续转换弹框 -->
		<el-dialog title="提示" :visible.sync="dialogTips" class="changephone_box agin_box" :close-on-click-modal="false"
			width="420px" append-to-body>
			<div class="content">继续转换将清空当前列表，请您先下载保存文档。是否继续转换？</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitTurn" size="mini">确 定</el-button>
				<el-button @click="dialogTips = false" size="mini">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import Sortable from "sortablejs";
import icon from "@comm/components/document-conversion/iconImg";
import mergeTurn from "@comm/components/document-conversion/mergeTurn";
import { getfilesize } from "@comm/utils/tools";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { packZipDownload, downloadUploadFile, fileTransfer, transferPoll, getTransferLongImg, imageToOfd, pubserviceUpload } from "@comm/api/document-conversion";
import $ from "jquery";
import Files from "@comm/utils/files";
import { getBrowerInfo } from "@comm/utils/useAgent";
import { buriedPoint, turnBuriedPoint } from "@comm/utils/buryingPoint.js";
import { getUserInfo } from "@comm/utils/auth";
export default {
	name: "imgTurn",
	components: {
		icon,
		ElImageViewer,
		mergeTurn
	},
	props: {
		fileListData: "",
		isShowData: false,
		isUploadImgData: false,
		attrsData: "",
		pageTypeData: "",
		imgtoOfdAginData: "",
		originFileIdData: {
			type: Object,
			default() {
				return {};
			}
		},

		isMergeTurnData: false,
		zhErrorData: false
	},
	data() {
		return {
			newFileList: this.fileListData,
			fileList: [],
			visible: false,
			options: {
				target: "invoice-info/upload",
				chunkSize: "2048000",
				fileParameterName: "upfile",
				maxChunkRetries: 1,
				testChunks: false,
				allowDuplicateUploads: true,
				headers: {
					// Authorization: getToken(),
				},
				query() { }
			},
			attrs: {
				accept: this.attrsData
			},
			interval: "",
			isMerge: false,
			allisTurnIng: false,
			dialogFolder: false,
			folderName: "",
			dialogDownZip: false,
			downZipName: "",
			uploadSuccessList: [],
			isUploadImg: this.isUploadImgData,
			selectData: [],
			selectRow: [],
			progressTurn: 0,
			zhSuccess: false,
			pageType: this.pageTypeData,
			imgtoOfdAgin: this.imgtoOfdAginData,
			isIndeterminate: true,
			isCheckbox: false,
			isLongImg: false,
			isLongImgend: false,
			radio: "",
			originFileId: this.originFileIdData,
			isDown: false,
			resultList: [],
			downTime: 0,
			isThumbShow: this.isShowData,
			isDelete: false,
			showViewer: false,
			viewImg: "",
			zhError: this.zhErrorData,
			isMergeTurn: this.isMergeTurnData,
			MergeData: null,
			allzhSuccessEnd: false,
			fileNameReg: /.*[\\\/:*?"<>|]+.*/,
			oldoriginFileId: {},
			isDowning: false,
			dialogTips: false,
			isReUpload: "",
			transfering: false,
			ishandleImgError: false,
			isLowVerIE: false,
			APIPort: process.env.APIPort,
			ticket: '',
			pollNum: 0,
		};
	},
	filters: {
		ellipsis(value) {
			if (!value) return "";
			let fileListArrayname = value;
			let fileNameSuffix1 = fileListArrayname;
			if (fileListArrayname.length > 15) {
				value = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
			}
			return value;
		}
	},
	watch: {
		attrsData(val) {
			this.attrs.accept = val;
		},
		zhErrorData(val) {
			this.zhError = val;
			// if (this.zhError && this.isUploadImg) {
			//   this.fileList = [];
			// }
		},
		isMergeTurnData(val) {
			this.isMergeTurn = val;
		},
		isShowData(val) {
			this.isThumbShow = val;
		},
		originFileIdData(val) {
			this.originFileId = val;
			if (!Object.keys(val).length) return;
			this.originFileId.fileTypeCase = this.originFileId.fileType.toLowerCase();
		},
		pageTypeData(val) {
			this.pageType = val;
		},
		isUploadImgData(val) {
			this.isUploadImg = val;
			this.zhError = false;
			if (!val && this.pageType == "toimg") {
				this.isIndeterminate = true;
				if (!this.radio) {
					this.radio = this.originFileId.fileTypeCase == "ofd" ? "3" : "6";
				}

				this.$nextTick(() => {
					this.handleCheckAllChange();
				});
			} else if (!val && this.pageType != "toimg" && !this.radio) {
				this.radio = "ofd";
			}
			if (!val) {
				let uploadSuccessList = [];
				this.fileList.forEach((item, index) => {
					if (item.upLoadSuccess) {
						uploadSuccessList.push(item);
					}
				});
				if (this.newFileList.length > 0) {
					this.selectData = [];
				} else {
					this.originFileId = this.oldoriginFileId;
				}
				this.uploadSuccessList = uploadSuccessList;
				if (this.uploadSuccessList.length > 0) {
					this.MergeData = null;

					// this.fileList = this.newFileList
				} else if (this.uploadSuccessList.length <= 0 && this.resultList.length > 0 && this.newFileList.length <= 0) {
					this.isDown = true;
				} else if (this.uploadSuccessList.length <= 0 && this.MergeData && this.newFileList.length <= 0) {
					this.isMergeTurn = true;
					this.isDown = true;
				}

				// if (this.newFileList.length <= 0 && this.MergeData) {
				//   this.isMergeTurn = true;
				//   this.isDown = true;
				// } else {
				//   this.isMergeTurn = false;
				// }

				this.$nextTick(() => {
					if (this.pageType != "toimg") {
						this.rowDrop();
					}
				});
			} else {
				this.isDown = false;
				this.isMergeTurn = false;
				this.oldoriginFileId = this.originFileId;
				this.originFileId = {};
			}
		},
		fileListData(val) {
			this.newFileList = val;
			if (this.newFileList.length > 0) {
				this.resultList = [];
			}
			this.newFileList.forEach((item) => {
				item.getfilesize = getfilesize(item.size);
			});

			if (
				this.imgtoOfdAgin ||
				this.pageType == "imgtoofd" ||
				this.pageType == "toimg" ||
				(!this.isDelete && !this.addUpLad && this.uploadSuccessList.length <= 0) ||
				(this.isDelete && !this.addUpLad) ||
				this.transfering ||
				this.isReUpload ||
				this.ishandleImgError
			) {
				this.fileList = this.newFileList;
			} else {
				this.fileList = [...this.fileList, ...this.newFileList];
			}
			return;
		},
		fileList(val) {
			this.fileList = val;
			let uploadSuccessList = [];
			val.forEach((item, index) => {
				item.index = index;
				item.flag = false;
				item.sfileType = item.fileType.toLowerCase();
				if (item.ghz) {
					item.ghz = true;
				} else {
					item.ghz = false;
				}
				

				if (item.upLoadSuccess && !this.allzhSuccessEnd) {
					uploadSuccessList.push(item);
				}
			});
			this.uploadSuccessList = uploadSuccessList;
		},
		imgtoOfdAginData(val) {
			this.imgtoOfdAgin = val;
			this.zhError = false;
			if (val) {
				this.fileList = this.newFileList;
			}
		},
		selectData(data) {
			let fileList = [];
			if (this.selectData.length > 0) {
				fileList = this.selectData;
			} else {
				fileList = this.newFileList;
			}
			if (fileList.length > 20) {
				fileList = fileList.slice(0, 20);
			}
			if (data.length == this.fileList.length || data.length == 20) {
				this.isIndeterminate = false;
				this.isCheckbox = !this.isIndeterminate;
			} else {
				this.isIndeterminate = true;
				this.isCheckbox = !this.isIndeterminate;
			}
			this.selectRow = [];
			if (data.length > 0) {
				data.forEach((item, index) => {
					item.flag = true;
					this.selectRow.push(this.fileList.indexOf(item));
				});
			}
		}
	},
	mounted() {
		//  if (this.pageType == "toimg") {
		//         this.isIndeterminate = !this.isIndeterminate;
		//         this.isCheckbox = !this.isIndeterminate;
		//         if (!this.isIndeterminate) {
		//           this.fileList.forEach((item) => {
		//             this.$refs.multipleTableTxt.toggleRowSelection(item, true);
		//           });
		//         }
		//       } else {
		//         this.rowDrop();
		//       }
		const { browserType, browserVersion } = getBrowerInfo();
		if (browserType == "IE") {
			this.isLowVerIE = true;
		}
	},
	methods: {
		chkstu: function (row, index) {
			return index <= 19 ? true : false;
		},
		handleImgError(e, file) {
			file.ghz = true;
			this.ishandleImgError = true;
			this.$set(this.fileList, file.index, file);
			e.currentTarget.src = require("@comm/images/document-conversion/ghz_icon.svg");
			
		},
		showViewerClose() {
			this.showViewer = false;
		},
		handleClickItem() {
			this.showViewer = true;
		},
		openBtn(file) {
			if ((file.sfileType == 'tif' || file.sfileType == 'tiff' || file.ghz || !file.upLoadSuccess) && !this.isDown) return
			this.showViewer = true;
			this.viewImg = file.url;
			let that = this;
			this.$nextTick(() => {
				$(".el-image-viewer__close").click(function () {
					that.showViewer = false;
					that.viewImg = "";
				});
			});
		},
		// 拖拽部分
		rowDrop() {
			if (this.pageType == "toimg") {
				return;
			}
			const tbody = document.querySelector(".el-table__body-wrapper tbody");
			const selft = this;
			if (selft.fileList.length > 0) {
				Sortable.create(tbody, {
					onEnd({ newIndex, oldIndex }) {
						let tData = JSON.parse(JSON.stringify(selft.fileList));
						const currRow = tData.splice(oldIndex, 1)[0];
						tData.splice(newIndex, 0, currRow);
						selft.fileList = tData;
						// selft.fileList = [];
						// setTimeout(() => {
						//   selft.fileList = tData;
						// }, 5);
					}
				});
			}
		},
		chooseLong() {
			// this.isLongImg
		},
		// 点击选中图片
		pinSelect(item, index) {
			if (this.pageType == "toimg" && item.index > 19 && !item.flag) {
				// this.$confirm("仅支持转换20张页面！", "提示", {
				//   cancelButtonText: "取消",
				//   confirmButtonText: "确定",
				//   showCancelButton: false,
				//   type: "warning",
				//   showClose: false,
				//   closeOnClickModal: false,
				//   closeOnPressEscape: false,
				//   lockScroll: false,
				// }).then(() => {});
			} else {
				this.isIndeterminate = true;
				this.isCheckbox = false;
				item.flag = !item.flag;
				this.$refs.multipleTableTxt.toggleRowSelection(item, item.flag);
			}
		},
		handleCheckAllChange() {
			this.isIndeterminate = !this.isIndeterminate;
			this.isCheckbox = !this.isIndeterminate;
			let fileList = [];
			if (!this.isIndeterminate && this.selectData.length > 0 && this.newFileList.length <= 0) {
				fileList = this.selectData;
			} else {
				this.$refs.multipleTableTxt.clearSelection();
				this.newFileList.forEach((item) => {
					item.flag = false;
				});
				this.selectData = [];
				fileList = this.newFileList;
			}
			if (fileList.length > 20) {
				fileList = fileList.slice(0, 20);
			}

			if (!this.isIndeterminate) {
				fileList.forEach((item) => {
					this.$refs.multipleTableTxt.toggleRowSelection(item, true);
				});
			} else {
				this.$refs.multipleTableTxt.clearSelection();
				this.fileList.forEach((item) => {
					item.flag = false;
				});
			}
		},
		chooseClass({ row, rowIndex }) {
			if (this.pageType == "toofd" || this.pageType == "imgtoofd") {
				return;
			}
			if (this.selectRow.includes(rowIndex)) {
				return "choose_class";
			}
		},
		handleSelectionChange(val) {
			let selectDataList = this.selectData;
			if (this.pageType == "toimg" && val.length > 20) {
				this.$refs.multipleTableTxt.clearSelection();
				selectDataList.forEach((row) => {
					this.$refs.multipleTableTxt.toggleRowSelection(row);
				});
				this.$confirm("仅支持转换20张页面！", "提示", {
					cancelButtonText: "取消",
					confirmButtonText: "确定",
					showCancelButton: false,
					type: "warning",
					showClose: false,
					closeOnClickModal: false,
					closeOnPressEscape: false,
					lockScroll: false
				}).then(() => { });
			} else {
				this.selectData = val;
			}
		},
		// 删除
		suspendBtn(file) {
			var index = this.fileList.indexOf(file);
			this.fileList.splice(index, 1);
			if (this.fileList.length <= 0) {
				this.submitBtn();
			} else {
				let data = {
					fileList: this.fileList,
					isShow: this.isThumbShow,
					isTurnShow: false,
					oldFileList: this.fileList,
					originFileId: this.originFileId
				};
				this.ishandleImgError = false;
				this.isDelete = true;
				this.$emit("endTurn", data);
			}
		},
		btnDown() {
			if (this.resultList.length <= 1) {
				this.downdImgBtn(this.resultList[0]);
			} else {
				this.downdBtn();
			}
		},
		// 下载
		downdBtn(file) {
			if (this.isDowning) {
				return;
			}
			this.isDowning = true;
			this.downTime = Date.parse(new Date());
			let list = [];
			let sizeTotal = 0;
			this.fileList.forEach((item) => {
				let itemArray = [];
				itemArray.push(item.fileIds);
				itemArray.push(item.fileName + "." + item.fileType);
				list.push(itemArray.toString());
				sizeTotal += parseInt(item.size || item.fileSize);
			});
			packZipDownload({
				list: list,
				fileZipName: this.originFileId.name
			})
				.then((res) => {
					this.downloadFile(1, res);
				})
				.catch((err) => {
					this.isDowning = false;
					if (err.code == "ECONNABORTED" && err.message.indexOf("timeout") != -1) {
						this.$alert("网络不佳或内容过大", "提示", {
							confirmButtonText: "确定"
						});
					}
					if (this.APIPort == 8001) {
						let nowTime = Date.parse(new Date());
						let time = nowTime - this.downTime;
						setTimeout(function () {
							buriedPoint("isDown", 104, 1, 1, 2, time, sizeTotal);
						}, 200);
					}
				});
		},
		// 下载
		downdImgBtn(file) {
			if (file.isDowning) return;
			file.isDowning = true;
			this.fileList.map((item, index) => {
				if (item.s == file.fileIds) {
					file.index = index;
				}
			});
			this.$set(this.fileList, file.index, file);
			this.downTime = Date.parse(new Date());
			downloadUploadFile({
				fileId: file.fileIds,
				fileName: encodeURIComponent(file.fileName + "." + file.fileType)
			}).then((res) => {
				this.downloadFile(2, res, file);
			})
				.catch((err) => {
					file.isDowning = false;
					this.fileList.map((item, index) => {
						if (item.s == file.fileIds) {
							file.index = index;
						}
					});
					this.$set(this.fileList, file.index, file);
					if (err.code == "ECONNABORTED" && err.message.indexOf("timeout") != -1) {
						this.$alert("网络不佳或内容过大", "提示", {
							confirmButtonText: "确定"
						});
					}
				});
		},
		downloadFile(type, res, file) {
			let that = this;
			Files.downloadFile(type, res, file, (type, file) => {
				this.isDowning = false;
				file.isDowning = false;
				this.$set(this.fileList, file.index, file); 
				that.$forceUpdate();
				if (this.APIPort == 8001) {
					let downloadFileType = "";
					let downloadType = 0;
					let size = 0;
					size = file.size;
					if (type == 1) {
						downloadType = 1;
						downloadFileType = 2;
						size = file.size;
					} else {
						downloadType = 0;
						downloadFileType = 3;
						size = that.fileList[0].size;
					}
					let nowTime = Date.parse(new Date());
					let time = nowTime - that.downTime;
					setTimeout(function () {
						buriedPoint("isDown", 104, 0, downloadType, downloadFileType, time, size);
					}, 200);
				}
			});
		},
		// 预览
		readApi(shortUrl) {
			let userInfo = JSON.parse(getUserInfo())
			let nickname = encodeURIComponent(encodeURIComponent(userInfo.nickname))
			const { href } = this.$router.resolve({
				path: `/r:${shortUrl}&&${nickname}`
			});
			window.open(href, "_blank");
		},
		reLoadTurn() {
			if (this.isDown) this.dialogTips = true;
			else this.reLoadTurnReset();
		},
		submitTurn() {
			this.reLoadTurnReset();
		},
		// 清空列表
		reLoadTurnReset() {
			this.isUploadImg = false;
			this.allisTurnIng = false;
			this.ishandleImgError = false;
			this.radio = "";
			this.isReUpload = "";
			this.isDelete = false;
			this.transfering = false;
			this.addUpLad = false;
			this.uploadSuccessList = [];
			this.dialogTips = false;
			this.isMerge = false;
			this.isLongImg = false;
			this.isDown = false;
			this.isLongImgend = false;
			this.zhError = false;
			this.isIndeterminate = true;
			this.isCheckbox = false;
			this.selectData = [];
			this.selectRow = [];
			this.allzhSuccessEnd = false;
			this.fileList = [];
			this.isShow = false;
			this.isAllDel = false;
			this.isMergeTurn = false;
			this.MergeData = null;
			let data = {
				fileList: [],
				isShow: false,
				oldFileList: [],
				isAllDel: false,
				isMergeTurn: false,
				MergeData: null
			};
			this.$emit("endTurn", data);
		},
		// 清空列表
		submitBtn() {
			this.isUploadImg = false;
			this.allisTurnIng = false;
			this.isDown = false;
			this.isLongImgend = false;
			this.ishandleImgError = false;
			this.zhError = false;
			this.radio = "";
			this.allzhSuccessEnd = false;
			this.selectData = [];
			this.selectRow = [];
			this.fileList = [];
			this.uploadSuccessList = [];
			this.isLongImg = false;
			this.visible = false;
			this.newFileList = [];
			this.isMergeTurn = false;
			this.MergeData = null;
			let data = {
				fileList: this.fileList,
				oldFileList: this.fileList,
				isShow: false,
				isTurnShow: false,
				isMergeTurn: this.isMergeTurn,
				MergeData: this.MergeData
			};
			this.$emit("endTurn", data);
		},
		// 上传
		onFileAdded(file, isReUpload) {
			this.isReUpload = isReUpload;
			// if (this.turnCount >= 5) {
			//   this.$confirm("今日转换次数已达上限5次", "", {
			//     confirmButtonText: "确定",
			//     type: "warning",
			//   }).then(() => {
			//     return;
			//   });
			// } else {
			//   this.zhSuccess = false;
			//   this.isDown = false;
			//   this.isDelete = false;
			//   this.$parent.onFileAdded(file);
			// }
			this.ishandleImgError = false;
			this.zhSuccess = false;
			// this.isDown = false;
			this.isDelete = false;
			this.isLongImgend = false;
			// this.selectData = [];
			// this.selectRow = [];
			// this.isIndeterminate= true,
			// this.isCheckbox= false,
			// this.isUploadImg = true;
			this.newFileList = [];
			// if(!this.isDown){
			//   this.originFileId={}
			// }
			// this.zhError
			// if (!this.isMergeTurn) {
			//   this.$refs.multipleTableTxt.clearSelection();
			// }

			if (this.isMergeTurn) {
				// this.isMergeTurn = false;
				this.fileList = [];
			}
			this.fileList.forEach((item, index) => {
				item.index = index;
			});
			if (this.pageType == "toimg") {
				// this.handleCheckAllChange();
				this.uploadSuccessList = [];
				this.isLongImg = false;
				this.visible = false;
				this.isMergeTurn = false;
				this.MergeData = null;
				this.radio = "";

				if (this.fileList.length <= 0 && !this.isDown) {
					this.isThumbShow = false;
				}

				let data = {
					fileList: this.fileList,
					oldFileList: this.fileList,
					isShow: this.isThumbShow,
					isMergeTurn: this.isMergeTurn,
					MergeData: this.MergeData,
					originFileId: this.originFileId,
					resultList: this.resultList
				};
				this.$emit("endTurn", data);
			} else {
				this.imgtoOfdAgin = false;
				this.pageType = "toofd";
				let data = {
					imgtoOfdAgin: false,
					fileList: this.fileList,
					MergeData: this.MergeData,
					isMergeTurn: false,
					isShow: true
				};
				this.$emit("AddUpload", data);
			}
			if (isReUpload) {
				this.oldoriginFileId = this.originFileId;
				file.isReUpload = true;
				file.cause = "";
				file.isUpLoading = true;
				file.wait = false;
			}
			this.$parent.onFileAdded(file, isReUpload, this.fileList);
		},
		onSubmitted(fileList) {
			this.$parent.onSubmitted(fileList);
		},
		//转换
		changeTurn() {
			if (this.pageType != "toimg") {
				this.fileList.forEach((item) => {
					this.$refs.multipleTableTxt.toggleRowSelection(item, true);
				});
			}
			if (this.selectData.length <= 0) {
				this.$message.error("请先选择图片");
				return;
			}
			// if (this.turnCount >= 5) {
			//   this.$confirm("今日转换次数已达上限5次", "", {
			//     confirmButtonText: "确定",
			//     type: "warning",
			//   }).then(() => {
			//     return;
			//   });
			// }
			if (this.isUploadImg || this.allisTurnIng || this.isDown || this.isLongImgend) {
			}
			if (this.pageType != "toimg" && this.uploadSuccessList.length > 1) {
				this.downZipName = "";
				this.dialogDownZip = true;
				this.$nextTick(() => {
					this.$refs.textFolder.focus();
				});
			} else {
				this.submitFolder();
			}
		},
		submitFolder() {
			if (this.fileList.length <= 1 && this.pageType == "toimg") {
				this.downZipName = this.fileList[0].name;
			}
			if (this.pageType != "toimg" && this.uploadSuccessList.length <= 1) {
				this.downZipName = this.uploadSuccessList[0].name;
			}
			if (this.dialogDownZip && !this.downZipName.trim()) {
				this.$message.error("文件名称不能为空");
				return;
			}
			if (this.dialogDownZip && !this.downZipName) {
				this.$message.error("请输入文档的名称");
				return;
			}
			if (this.fileNameReg.test(this.downZipName)) {
				this.$message.error('文件名称不能包含下列任何字符：\\/:*?"<>|');
				return;
			}
			this.ishandleImgError = false;
			this.allisTurnIng = true;
			this.dialogDownZip = false;
			this.transfering = true;
			if (this.pageType == "toimg") {
				this.fileList = [];
			}
			// this.fileList = [];
			// if (this.pageType != "toimg") {
			//   this.getMessage(this.fileList);
			// }
			if (this.isLongImg) {
				this.getLongTransfer();
			} else {
				this.getTransfer();
			}
		},
		//长图转换
		getLongTransfer() {
			this.downTime = Date.parse(new Date());
			this.progressTurn = 0;
			let that = this;
			let fileIds = [];
			if (this.pageType != "toimg") {
				this.originFileId.fileType = this.radio;
				if (this.uploadSuccessList.length > 1) {
					this.originFileId.name = this.downZipName;
				} else {
					this.originFileId.name = this.uploadSuccessList[0].name;
				}
				let fileListArrayname = this.downZipName;
				let fileNameSuffix1 = fileListArrayname;
				if (fileListArrayname.length > 15) {
					this.originFileId.slname = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
				}
				//  this.originFileId.fileType=this.radio
				this.uploadSuccessList.forEach((item, index) => {
					fileIds.push(index + 1);
				});
			} else {
				this.selectData.forEach((item, index) => {
					fileIds.push(item.fileId);
				});
			}

			let isAllPage = 0;
			if (!this.isIndeterminate) {
				isAllPage = 0;
			} else {
				isAllPage = 1;
			}
			let data = {
				fileIds: fileIds,
				transferType: this.radio,
				dirType: 3
			};
			getTransferLongImg(data)
				.then((res) => {
					if (!res.data) {
						this.zhError = true;
						this.allisTurnIng = false;
						this.uploadSuccessList = [];
						if (this.APIPort == 8001) {
							let nowTime = Date.parse(new Date());
							let time = nowTime - this.downTime;
							let pageType = "";
							if (this.pageType == "toofd") {
								pageType = "imgtoofd";
							} else {
								pageType = this.pageType;
							}
							turnBuriedPoint(pageType, this.originFileId.name, this.originFileId.size, this.radio, time, 0, 2, 0, 1);
						}
						return;
					}

					let fileType = "";
					if (this.radio == "3" || this.radio == "6") {
						fileType = "jpg";
					} else if (this.radio == "4" || this.radio == "7") {
						fileType = "png";
					} else {
						fileType = "tiff";
					}
					res.data.forEach((item) => {
						item.zhSuccess = true;
						item.disable = true;
						item.isUpLoading = false;
						item.isTurnIng = false;
						item.fileIds = item.fileId;
						item.fileType = fileType;
						item.name = item.fileName;
					});
					this.isDown = true;
					this.resultList = res.data;
					res.data.map((item) => {
						item.isDowning = false;
					});
					this.fileList = res.data;
					this.$forceUpdate();
					this.isLongImgend = true;
					this.zhSuccess = true;
					this.allzhSuccessEnd = true;
					this.allisTurnIng = false;
					this.selectData = [];
					this.isIndeterminate = true;
					this.isCheckbox = false;
					if (this.APIPort == 8001) {
						let nowTime = Date.parse(new Date());
						let time = nowTime - this.downTime;
						let pageType = "";
						if (this.pageType == "toofd") {
							pageType = "imgtoofd";
						} else {
							pageType = this.pageType;
						}
						turnBuriedPoint(pageType, this.originFileId.name, this.originFileId.size, this.radio, time, 1, 2, 0, 1);
					}
				})
				.catch(() => {
					this.zhError = true;
					this.allisTurnIng = false;
					if (this.APIPort == 8001) {
						let nowTime = Date.parse(new Date());
						let time = nowTime - this.downTime;
						let pageType = "";
						if (this.pageType == "toofd") {
							pageType = "imgtoofd";
						} else {
							pageType = this.pageType;
						}
						turnBuriedPoint(pageType, this.originFileId.name, this.originFileId.size, this.radio, time, 0, 2, 0, 1);
					}
				});
		},
		getTransfer(isReTurn) {
			this.downTime = Date.parse(new Date());
			this.progressTurn = 0;
			let fileIds = [];
			let pages = [];
			if (isReTurn) {
				this.allzhSuccessEnd = false;
				this.allisTurnIng = true;
				this.zhError = false;
				this.isMergeTurn = false;
			}
			if (this.pageType != "toimg") {
				this.originFileId.fileType = this.radio;
				if (this.uploadSuccessList.length > 1) {
					this.originFileId.name = this.downZipName;
				} else {
					this.originFileId.name = this.uploadSuccessList[0].name;
				}
				let fileListArrayname = this.downZipName;
				let fileNameSuffix1 = fileListArrayname;
				if (fileListArrayname.length > 15) {
					this.originFileId.slname = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
				}
				this.uploadSuccessList.forEach((item, index) => {
					fileIds.push(item.fileConversionNeedDTO);
					pages.push(index + 1);
				});
			} else {
				if (this.isReUpload) {
					this.originFileId = this.oldoriginFileId;
				}
				this.selectData.forEach((item, index) => {
					fileIds.push(item.fileConversionNeedDTO);
					pages.push(item.index + 1);
				});
			}
			let that = this;
			let url = "";
			let data = {};
			if (this.pageType == "toimg") {
				data = {
					fileConversionNeedDTO: this.originFileId.fileConversionNeedDTO,
					pages: pages,
					transferType: this.radio,
					dirType: 3
				};
			} else {
				data = {
					fileConversionNeedDTOs: fileIds,
					fileName: this.downZipName,
					paperSize: 0,
					paperDirection: 0,
					paperMargin: 0,
					outputFormat: this.radio,
					dirType: 4
				};
			}
			let pamers = ''
			pamers = imageToOfd(this.pageType == "toimg", data)

			//transferType 1文件转ofd   2文件转pdf
			pamers.then((res) => {
				if (!res.data) {
					this.zhError = true;
					this.allisTurnIng = false;
					this.errorTurnMd();
					// clearInterval(that.interval);
					return;
				}
				let that = this;
				this.pollNum = 0
				setTimeout(function () {
					that.getTransferPoll(res.data);
				}, 5000);
			})
				.catch((err) => {
					this.zhError = true;
					this.allisTurnIng = false;
					this.errorTurnMd();
					// clearInterval(that.interval);
					// that.$message.error(err.msg);
				});
		},
		//轮询
		getTransferPoll(data) {
			this.pollNum++
			if (this.pollNum > 10) {
				this.zhError = true;
				this.allisTurnIng = false;
				this.pollNum = 0
				this.errorTurnMd();
				this.$message.error('网络异常，请重试！')
				return
			}
			let that = this;
			// clearInterval(that.interval);
			transferPoll(data)
				.then((res) => {
					if (res.data.status == 1) {
						setTimeout(function () {
							that.getTransferPoll(data);
						}, 3000);
						// that.interval = setInterval(function () {
						//   that.getTransferPoll(data);
						// }, 3000);
					} else if (res.data.status == 0) {
						this.isUploadImg = false;
						this.isDown = false;
						this.selectData = [];
						this.zhError = false;
						this.isLongImgend = false;
						this.allzhSuccessEnd = true;
						this.isCheckbox = false;
						this.zhSuccess = true;
						this.pollNum = 0
						// clearInterval(that.interval);
						this.allisTurnIng = false;
						this.uploadSuccessList = [];
						localStorage.setItem("turnCount", res.data.count);
						this.turnCount = localStorage.turnCount;
						this.isDown = true;
						if (this.pageType == "toimg") {
							res.data.result.forEach((item) => {
								item.name = item.fileName;
								item.zhSuccess = true;
								item.fileIds = item.fileId;
								item.fileType = this.radio == "3" || this.radio == "6" ? "jpg" : this.radio == "4" || this.radio == "7" ? "png" : "tiff";
							});
							// this.isDown=true
							this.resultList = res.data.result;
							res.data.result.map((item) => {
								item.isDowning = false;
							});
							this.fileList = res.data.result;
							let fileType = this.radio == "3" || this.radio == "6" ? "jpg" : this.radio == "4" || this.radio == "7" ? "png" : "tiff";
							let sizeTotal = 0;
							this.resultList.forEach((item) => {
								sizeTotal += item.size;
							});
							let isAllPage = 0;
							if (!this.isIndeterminate) {
								isAllPage = 0;
							} else {
								isAllPage = 1;
							}
							this.isIndeterminate = true;
							if (this.APIPort == 8001) {
								let nowTime = Date.parse(new Date());
								let time = nowTime - this.downTime;
								let pageType = "";
								if (this.pageType == "toofd") {
									pageType = "imgtoofd";
								} else {
									pageType = this.pageType;
								}
								turnBuriedPoint(pageType, this.originFileId.name, sizeTotal, fileType, time, 1, 2, 0, 1);
							}
							return;
						} else {
							res.data.result.forEach((item) => {
								item.zhSuccess = true;
								item.disable = true;
								item.isUpLoading = false;
								item.isTurnIng = false;
								item.fileIds = item.fileId;
								item.name = item.fileName;
								item.size = item.fileSize;
								item.fileType = (this.pageType == "toofd" && this.radio == "ofd") || (this.pageType == "imgtoofd" && this.radio == "ofd") ? "ofd" : "pdf";
							});
							res.data.result.map((item) => {
								item.isDowning = false;
								let fileListArrayname = item.name;
								let fileNameSuffix1 = fileListArrayname;
								if (fileListArrayname.length > 15) {
									item.slname = fileListArrayname.substring(0, 14) + "..." + fileNameSuffix1.substring(fileNameSuffix1.length - 1, fileNameSuffix1.length);
								}
							});
							this.fileList = res.data.result;
							this.isMergeTurn = true;
							this.uploadSuccessList = [];
							this.MergeData = res.data.result[0];
							this.getpubserviceUpload(this.MergeData)

						}
					} else {
						this.zhError = true;
						this.allisTurnIng = false;
						this.pollNum = 0
						this.errorTurnMd();
						// clearInterval(that.interval);
						// that.$message.error(res.msg);
					}
				})
				.catch((res) => {
					this.zhError = true;
					this.allisTurnIng = false;
					this.pollNum = 0
					this.errorTurnMd();
					// clearInterval(that.interval);
					// that.$message.error(res.msg);
				});
		},
		getpubserviceUpload(file) {
			pubserviceUpload({
				fileName: file.fileName + '.' + file.fileType,
				fileUrl: file.url,
				fileType: file.fileType,
				fileSize: file.fileSize,
				fileId: file.fileId,
				zipPassword: '' //解压密码
			})
				.then((res) => {
					let data = res.data.data;
					if (data) {
						this.MergeData.shortUrl = data.shortUrl
						this.readApi(this.MergeData.shortUrl);
						if (this.APIPort == 8001) {
							let nowTime = Date.parse(new Date());
							let time = nowTime - this.downTime;
							let pageType = "";
							if (this.pageType == "toofd") {
								pageType = "imgtoofd";
							} else {
								pageType = this.pageType;
							}
							turnBuriedPoint(pageType, this.MergeData.name, this.MergeData.size, this.MergeData.fileType, time, 1, 2, 0, 1);
						}
					}
				})
		},
		errorTurnMd() {
			let fileType = this.radio == "3" || this.radio == "6" ? "jpg" : this.radio == "4" || this.radio == "7" ? "png" : "tiff";
			let sizeTotal = 0;
			this.resultList.forEach((item) => {
				sizeTotal += item.size;
			});
			let isAllPage = 0;
			if (!this.isIndeterminate) {
				isAllPage = 0;
			} else {
				isAllPage = 1;
			}
			if (this.APIPort == 8001) {
				let nowTime = Date.parse(new Date());
				let time = nowTime - this.downTime;
				let pageType = "";
				if (this.pageType == "toofd") {
					pageType = "imgtoofd";
				} else {
					pageType = this.pageType;
				}
				turnBuriedPoint(pageType, this.originFileId.name, sizeTotal, fileType, time, 0, 2, 0, 1);
			}
		}
	}
};
</script>
<style lang="scss">
.mycell .el-checkbox {
	display: none;
}

.el-button.btn_down {
	background-color: rgba(0, 0, 0, 0.06) !important;
	opacity: 0.5 !important;
	color: #606266 !important;
	cursor: not-allowed;
	padding: 1px 0 !important;
	border: 1px solid #dcdfe6 !important;
	width: 56px !important;
	text-align: center;
}

.el-button.btn_down i {
	margin-right: 4px;
}

.el-table--enable-row-transition .el-table__body td {
	background: none;
}

.choose_all {
	padding-top: 14px;

	.el-checkbox__input {
		width: 30px;
	}
}

.thumb_list {
	.el-table {
		.el-popover {
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: 12px;
			min-width: auto;
			box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
			color: #8b97af;
		}

		.el-popover--plain {
			padding: 5px;
		}
	}

	.el-table th:first-child>.cell,
	.el-table td:first-child>.cell {
		padding: 0 !important;
	}

	.el-table-column--selection .cell {
		padding: 0 !important;
	}

	.el-button:hover,
	.el-button--default:focus,
	.el-button:active {
		background: none;
		border: 1px solid #dcdfe6;
		color: #606266;
	}

	// .el-table--enable-row-hover .el-table__body tr:hover>td{
	//   background: none!important;
	// }
	.el-button.is-disabled,
	.el-button.is-disabled:focus,
	.el-button.is-disabled:hover {
		color: #c0c4cc;
	}

	.el-button--primary.is-disabled,
	.el-button--primary.is-disabled:active,
	.el-button--primary.is-disabled:focus,
	.el-button--primary.is-disabled:hover {
		color: #fff;
		background-color: #a0cfff;
		border-color: #a0cfff;
	}

	.el-button--primary:hover,
	.el-button--primary:active,
	.el-button--primary:focus {
		background-color: #14a8f0;
		border-color: #14a8f0;
		color: #fff;
	}

	.el-radio {
		margin-right: 12px !important;
	}

	.el-table tr input[type="checkbox"] {
		display: none;
	}

	.el-checkbox__label {
		span {
			padding-left: 4px;
			font-size: 14px;
			color: #8b97af;
		}
	}

	.el-checkbox__input.is-disabled+span.el-checkbox__label {
		span {
			color: #c0c4cc !important;
		}
	}

	.el-radio__input.is-disabled+span.el-radio__label,
	.el-checkbox__input.is-disabled.is-checked+.el-checkbox__label {
		color: #c0c4cc !important;
	}

	.el-checkbox__input.is-checked+.el-checkbox__label,
	.el-radio__input.is-checked+.el-radio__label {
		color: #606266 !important;
	}

	.el-table td {
		padding: 0 !important;
		height: auto;
	}

	.el-table .cell {
		width: 100%;
		height: 100%;
		position: relative;
		text-align: center;
		line-height: 22px;
	}

	.el-table .cell a,
	.el-table .cell a:hover,
	.el-table .cell p {
		color: #36425a;
		display: block;
		text-align: center;
		margin-bottom: 0;
		font-size: 12px;
		line-height: 22px;
		padding: 0 16px;
		overflow: hidden;
		/*超出部分隐藏*/
		white-space: nowrap;
		/*不换行*/
		text-overflow: ellipsis;
		/*超出部分文字以...显示*/
		text-decoration: none;
	}

	.el-table .cell a,
	.el-table .cell a:hover {
		padding: 0;
		vertical-align: middle;
		display: inline-block;
	}

	.el-table .cell a.name {
		margin: 0;
		width: 100%;
		color: #36425a;

		padding: 4px 16px 0;
	}

	tbody {
		width: 100%;
		display: block;
		text-align: left;
		padding-left: 23px;
	}

	.el-table.no_class .cell p,
	.el-table.no_class .cell a {
		display: inline-block;
		vertical-align: middle;
		padding: 0;
	}

	.el-table.no_class .cell p {
		padding-right: 4px;
	}

	.el-table.no_class .cell a.name {
		padding: 0;
		width: auto;
		text-align: left;
		max-width: 75%;
	}

	.el-table__body,
	.el-table__footer,
	.el-table__header,
	td {
		display: block !important;
		border: none !important;
		padding: 0;
	}

	.el-table tr {
		width: 18.4%;
		height: 248px;
		background: #ffffff;
		// border-radius: 2px;
		border: 1px solid #d8d8d8;
		display: inline-block;
		margin: 15px 8.5px 14px;
		position: relative;
		box-sizing: border-box;

		&:hover,
		&.choose_class {
			cursor: pointer;
			border: 1px solid #14a8f0;
		}

		img {
			width: auto;
			height: auto;
		}
	}

	// .el-table.class_isdown {
	//   margin-top: 33px !important;
	// }
	// .el-table.class_isdown tr {
	//   height: 262px;
	// }
	.choose_class td:nth-child(2) {
		box-sizing: border-box;
		outline: none;

		&>td,
		&>td:focus {
			outline: none;
		}
	}

	.no_class .choose_class,
	.class_isdown .choose_class {
		border: 1px solid #d8d8d8;
	}

	.el-table--enable-row-hover .el-table__body tr:hover>td {
		background: transparent !important;
	}

	.el-table::before {
		display: none;
	}

	.el-table--enable-row-transition .el-table__body td:first-child>.cell {
		padding: 0 !important;
	}

	.el-table__body td:nth-child(1) {
		padding-top: 10px;
		position: absolute;
		right: -8px;
		top: -4px;
		width: 30px;
	}

	.el-table__body td:nth-child(2) {
		// height: 186px;
		padding-top: 0 !important;
		// display: flex !important;
		// align-items: center;
		// justify-content: center;
	}

	.el-table__body td:nth-child(2) .cell {
		width: 100%;
		height: 209px;
		background: #fff;
		padding: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 0 10px;

		.pic {
			width: auto;
			height: auto;
			display: flex;
			flex-direction: column;
			align-content: center;
			justify-content: center;
			margin: 0 auto;
			position: relative;

			.repoll_btn {
				font-size: 14px;
				color: #14a8f0;
				line-height: 22px;
				padding-top: 8px;
				text-decoration: underline;
				position: relative;
				z-index: 99;
			}

			img {
				margin: 0 auto;
				max-height: 209px;
				max-width: 182px;
			}

			.iconImg {
				width: 48px;
				height: 48px;
				margin: 0 auto;
			}

			.longPic {
				width: 182px;
				max-height: none;
			}

			.open {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: 32px;
				height: 32px;
				border-radius: 50%;
				background: rgba(0, 0, 0, 0.79);
				padding: 4px;
				display: none;
			}
		}
	}

	.no_class .el-table__body td:nth-child(2) {
		height: 209px;
		margin-bottom: 8px;
	}

	.no_class .el-table__body td:nth-child(3) {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		display: flex;
		align-items: center;
	}

	.no_class .el-table__body td:nth-child(2) .cell {
		width: 100%;
		height: 209px;
		padding: 0;
		background: #fff;
		border-radius: 2px;

		.pic {
			overflow: hidden;

			img {
				max-height: 209px;
			}

			.iconImg {
				width: 48px;
				height: 48px;
				margin: 0 auto;
			}

			.longPic {
				width: 182px;
				max-height: none;
			}
		}

		.fail_bj {
			background: #f5f7f9;
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
		}
	}

	// .class_isdown .el-table__body td:nth-child(2) .cell {
	//   height: 200px;
	//   .pic {
	//     img {
	//       max-height: 200px;
	//     }
	//   }
	// }
	.el-table .el-table__body td:nth-child(3),
	.class_isdown .el-table__body td:nth-child(3),
	.no_class .el-table__body td:nth-child(3) {
		z-index: 999;
	}

	.no_class .el-table__body td:last-child,
	.class_isdown .el-table__body td:nth-child(4),
	.el-table .el-table__body td:nth-child(4),
	.class_isdown .el-table__body td:last-child {
		position: absolute;
		top: 0;
		right: 0;
		width: 100%;
		height: 100%;

		&:hover {
			display: block;
		}

		.hover_bj {
			pointer-events: none;
			position: absolute;
			top: 0;
			right: 0;
			width: 100%;
			height: 100%;
			background: linear-gradient(180deg,
					#60b7ff 0%,
					rgba(96, 179, 255, 0.24) 100%);
			border-radius: 2px;
			opacity: 0.3;

			&.tips {
				pointer-events: inherit;
			}
		}

		.del_icon {
			position: absolute;
			top: 0;
			right: 0;
			z-index: 99;
		}

		.icon_box {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);

			.open {
				width: 64px;
				height: 24px;
				background: #fff;
				border-radius: 1px;
				font-size: 12px;
				line-height: 24px;
				color: #36425a;
				display: flex;
				align-items: center;
				justify-content: center;

				&:hover {
					background: #14a8f0;
					color: #fff;

					.fdj_hs_icon {
						background: url("../../../images/document-conversion/fdj_hs_icon_active.png") 0 0 no-repeat;
						background-size: 100% 100%;
						cursor: pointer;
					}

					.downimg_icon {
						background: url("../../../images/document-conversion/downimg_icon_active.png") 0 0 no-repeat;
						background-size: 100% 100%;
						cursor: pointer;
					}
				}

				&.down {
					margin-bottom: 12px;
				}

				.downimg_icon {
					width: 12px;
					height: 12px;
					margin-right: 6px;
				}
			}
		}
	}

	.class_isdown .el-table__body td:last-child {
		text-align: center;
	}

	.no_class .el-table__body td:nth-child(1),
	.el-table--enable-row-hover.no_class .el-table__body tr:hover>td:nth-child(1),
	.no_class .el-table__body td:last-child,
	.class_isdown .el-table__body td:last-child,
	.el-table .el-table__body td:nth-child(4) {
		visibility: hidden !important;
	}

	.choose_class>td:nth-child(1),
	.choose_class>td:last-child,
	.el-table--enable-row-hover .el-table__body tr:hover>td:nth-child(1),
	.el-table--enable-row-hover.no_class .el-table__body tr:hover>td:last-child,
	.el-table--enable-row-hover.class_isdown .el-table__body tr:hover>td:last-child,
	.el-table--enable-row-hover.el-table .el-table__body tr:hover>td:nth-child(4) {
		visibility: visible !important;
	}

	.no_class .choose_class>td:nth-child(1),
	.no_class .choose_class>td:last-child .no_class .el-table__body tr:hover>td:nth-child(1),
	.class_isdown .el-table__body tr>td:nth-child(1),
	.class_isdown .el-table__body tr:hover>td:nth-child(1) {
		visibility: hidden !important;
	}

	.el-icon-star-off.active:before {
		color: orange;
	}

	.el-dropdown-menu__item {
		span {
			display: block;
			width: 100%;
			height: 100%;
		}
	}

	.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:active,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		background: #fafafa;
		color: rgba(0, 0, 0, 0.8);
	}
}
</style>
<style lang="scss" scoped>
.changephone_box {
	.content {
		.el-input {
			width: 85%;
			float: left;
		}

		span {
			display: block;
			float: left;
			padding-top: 15px;
		}
	}
}

.thumb_list {
	height: 100%;

	// .long_zip:hover{
	//       border: 1px solid #14a8f0!important;
	// }
	.turn_ing {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 16px;
		color: #6d7278;
		line-height: 22px;

		.turn_box {
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-bottom: 24px;
		}
	}

	.radio_box {
		display: inline-block;
		margin: 0 20px 0 32px;
		font-size: 14px;
		color: #8b97af;

		&.disabled {
			color: #c0c4cc;

			.el-radio__input .el-radio__inner,
			.el-radio__input.is-checked .el-radio__inner {
				background-color: #f5f7fa !important;
				border-color: #e4e7ed !important;
			}

			.thumb_list .el-radio__input+span.el-radio__label,
			.thumb_list .el-checkbox__input.is-checked+.el-checkbox__label {
				color: #c0c4cc !important;
			}
		}
	}

	.zip_box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		img {
			width: 63px;
		}

		p {
			margin: 18px 0;
		}
	}

	label {
		margin: 0;
	}

	.el-table .cell {
		text-align: center !important;
		line-height: 22px !important;
	}

	.title {
		line-height: 46px;
		height: 46px;
		background: #f5f7f9;
		padding: 0 32px;
		font-size: 12px;
		color: #8b97af;
		text-align: left;

		&.active {
			visibility: hidden;
		}
	}

	.uploader {
		width: auto;
		padding: 0 !important;
		border: none !important;

		&.disabled {
			color: #c0c4cc;
			cursor: not-allowed;
			background-image: none;
			background-color: #fff;
			border-color: #ebeef5;

			.uploader-btn {
				color: #c0c4cc;
				font-weight: normal;
			}
		}
	}

	.downZip {
		color: #36425a;
		font-size: 16px;

		&:hover {
			cursor: pointer;
			color: #15b2ff;
		}

		&:focus,
		&:active {
			color: #1299d9;
		}

		&.disable {
			color: #c0c4cc;
			position: relative;
		}
	}

	.uploader-btn {
		margin: 0;
		padding: 8px 19px;
		line-height: 22px;
		border: 1px solid #d7d9de;
		color: #36425a;
		border-radius: 2px;
		font-weight: normal;
		&:hover {
			background: none !important;
			border: 1px solid #15b2ff !important;
			color: #15b2ff !important;
		}
	}

	// .el-table {
	//   overflow-y: auto;
	// }

	.el-table {
		padding: 0;
	}

	.no_list {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		color: #242f44;
		line-height: 22px;
		height: 100%;

		img {
			width: 64px;
			height: 64px;
		}
	}

	.fail_box {
		text-align: left;
		margin-top: 66px;
		line-height: 100%;

		a {
			padding-left: 12px;
			font-size: 16px;
			color: #242f44;
			line-height: 22px;
		}
	}

	.cs_button_box {
		text-align: left;
		margin-top: 32px;

		span {
			font-size: 14px;
			color: #36425a;
			line-height: 22px;
			width: 64px;
			display: inline-block;
			text-align: center;
			margin-right: 44px;
		}
	}

	.table_bottom {
		height: 88px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 32px;
		border-top: 1px #f3f4f5 solid;

		.left {
			.hb_box {
				display: inline-block;
				font-size: 14px;
				color: #4f5d79;
				line-height: 22px;
			}
		}
	}
}

.el-table td div.fonts {
	display: inline-block;

	a {
		font-size: 14px;
		color: #242f44;
		line-height: 22px;

		&:hover {
			color: #242f44;
			text-decoration: none;
		}
	}
}

.content_table {
	overflow-y: auto;
	height: 100%;
}

.no_table {
	text-align: center;
	font-size: 14px;
	color: #909399;
	line-height: 60px;
}

.list {
	color: rgba(0, 0, 0, 0.4);

	h2 {
		font-size: 12px;
		color: rgba(0, 0, 0, 0.2);
		line-height: 16px;
		font-weight: normal;
		margin: 13px 0 15px;
	}

	.list_content {
		border-bottom: 1px #e2e2e2 solid;
	}

	.cell {
		font-size: 12px;
		color: rgba(0, 0, 0, 0.4);
		text-align: center;

		.icon {
			width: 60%;
			display: block;
			margin: 0 auto 12px;
		}

		.fonts {
			display: block;
			text-align: center;
			padding: 0 20px;
		}

		a {
			word-break: keep-all;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-weight: normal;
			color: rgba(0, 0, 0, 1);
			font-size: 14px;
			cursor: pointer;
			margin-bottom: 3px;

			&:hover {
				color: #409eff;
			}

			&.nopoint {
				cursor: initial;

				&:hover {
					color: rgba(0, 0, 0, 1);
					background: none;
				}
			}
		}

		p {
			margin-top: 2px;
			font-size: 12px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			height: 23px;
			line-height: 23px;

			span {
				padding-right: 10px;
			}
		}
	}
}

.no_file {
	p {
		font-size: 16px;
		font-weight: 400;
		color: #6d7278;
		line-height: 22px;
	}

	#loading1 {
		width: 100%;
		height: 30px;
	}
}
</style>


// WEBPACK FOOTER //
// src/comm/components/document-conversion/imgTurn/index.vue